import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-height-spacer',
  templateUrl: './height-spacer.component.html',
  styleUrls: ['./height-spacer.component.scss']
})
export class HeightSpacerComponent implements OnInit {

  @Input() height: string = "";

  constructor() { }

  ngOnInit(): void {
  }

}
